<div 
  class="border-2 border-gray-400 rounded-3xl overflow-hidden hover:shadow-lg transition-shadow cursor-pointer bg-white"
  (click)="navigateToEvent()"
>
  @if (event) {
    <div class="aspect-square relative">
      <img 
        [src]="getEventImage()" 
        [alt]="event.nombre"
        class="w-full h-full object-cover"
      />
    </div>
    <div class="p-4">
      <h3 class="font-bold text-lg mb-2 line-clamp-2">{{ event.nombre }}</h3>
      @if (event.tipoevento !== 'tren') {
        <p class="text-sm text-gray-600 mb-1">
          <span class="font-medium">{{ formatDate(event.fecha_hora) }}</span> - {{ formatTime(event.fecha_hora) }}
        </p>
      } @else {
        <div class="text-sm mb-1 h-5"></div>
      }
      <p class="text-sm text-gray-600 line-clamp-1">{{ event.lugar }}</p>
      <span class="inline-block mt-2 text-xs bg-gray-200 text-gray-700 px-3 py-1 rounded-full">{{ event.categoria }}</span>
    </div>
  } @else {
    <!-- Skeleton loader sin texto -->
    <div class="aspect-square bg-gray-200 animate-pulse"></div>
    <div class="p-4">
      <div class="h-6 bg-gray-200 rounded animate-pulse mb-2"></div>
      <div class="h-4 bg-gray-200 rounded animate-pulse w-3/4 mb-1"></div>
      <div class="h-4 bg-gray-200 rounded animate-pulse w-1/2"></div>
    </div>
  }
</div>
